import axios, { type AxiosError } from "axios";

const api = axios.create({
  baseURL: `${process.env.API_URL || ""}/api`,
  withCredentials: true,
  headers: { "Content-Type": "application/json" },
});

let onUnauthorized: (() => void) | null = null;

export function setOnUnauthorized(cb: () => void) {
  onUnauthorized = cb;
}

api.interceptors.response.use(
  (res) => res,
  (err: AxiosError) => {
    const url = err.config?.url ?? "";
    if (err.response?.status === 401 && !/\/auth\/google/.test(url)) {
      onUnauthorized?.();
    }
    return Promise.reject(err);
  },
);

export function extractErrorMessage(err: unknown): string {
  if (axios.isAxiosError(err)) {
    const data = err.response?.data as { message?: string | string[] } | undefined;
    if (data?.message) {
      return Array.isArray(data.message) ? data.message.join(", ") : data.message;
    }
    return err.message;
  }
  if (err instanceof Error) return err.message;
  return "Unknown error";
}

export default api;
